export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "asc";
  SortOrder["DESC"] = "desc";
  SortOrder["NO_ORDER"] = "no_order";
  return SortOrder;
}({});
export { AnnotationUpdateEmitter, AnnotationUpdateEvent } from './annotation';
export { ToolbarSize, ToolbarWidths, ToolbarWidthsNext, ToolbarWidthsFullPage, ToolbarWidthsFullPageNext } from './toolbar';

// DEPREACTED

/**
 * @depreacted
 *
 * Please use ExtractPresetAPI from "@atlaskit/editor-common/preset" instead.
 */